<template>
	<sf-data-table
		ref="langTable"
		paging
		height="500px"
		:columns="columns"
		:rows="rows"
		:pageUnit="commCdLangModal.groups.pageUnit"
		:totalSize="commCdLangModal.groups.totalSize"
		:currentPage="commCdLangModal.groups.currentPage"
		@changedPage="changedPage"
		:addRowDatas="addRowDatas"
		:span-method="objectSpanMethod"
		:stripe="false"
		:selection="commCdLangModal.isButtonOpened"
	>
		<template v-if="commCdLangModal.isButtonOpened" v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plus" :onClick="addAction">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="saveAction">{{ getMessage_('SWCC000138') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="deleteAction">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/CommonCode/store/helpers';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	data() {
		return {
			addRowDatas: [],
			currentTableData: null,
			selectedRow: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		columns() {
			let columns = [];
			if (this.commCdLangModal.isButtonOpened) {
				columns = [
					{
						label: this.getMessage_('SWCC001002'),
						prop: 'langId',
						minWidth: '180px',
						sortable: false,
						form: {
							type: 'select',
							options: this.gridLangCdype,
							isDisabled: this.isDisabled
							// SWCC000355
						}
					},
					{
						label: this.getMessage_('SWCC000339'),
						prop: 'langCd',
						minWidth: '150px',
						sortable: false
					},
					{
						label: this.getMessage_('SWCC000338'),
						prop: 'langVal',
						minWidth: '300px',
						sortable: false,
						form: {
							type: 'input'
						}
					}
				];
			} else {
				columns = [
					{
						label: this.getMessage_('SWCC001002'),
						prop: 'langId',
						minWidth: '180px',
						sortable: false,
						clickEvent: this.selectLangId,
						highlight: true,
						sortable: false,
						edit: true
					},
					{
						label: this.getMessage_('SWCC000339'),
						prop: 'langCd',
						minWidth: '150px',
						sortable: false
					},
					{
						label: this.getMessage_('SWCC000338'),
						prop: 'langVal',
						minWidth: '300px',
						sortable: false
					}
				];
			}
			return columns;
		},
		rows() {
			return this.commCdLangRows;
		},
		schema1() {
			return yup.array().of(
				yup.object().shape({
					langId: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC001002')])) //{0}은(는) 팔수 입력 값 입니다. , 다국어 ID
				})
			);
		},
		schema2() {
			return yup.array().of(
				yup.object().shape({
					langCd: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000340')])), //{0}은(는) 팔수 입력 값 입니다. , 메세지타입
					langVal: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000341')])) //{0}은(는) 팔수 입력 값 입니다. , 메세지내용
				})
			);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		// Basic methods
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.selectCommCdLangList_({ currentPage: currentPageVal, pageUnit: pageUnitVal })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (this.currentTableData || this.currentTableData == null || this.currentTableData != this.$refs.langTable.getTable().tableData) {
				if (this.currentTableData != null && this.currentTableData.length != this.$refs.langTable.getTable().tableData.length)
					this.makeAddDatas();
				this.currentTableData = this.$refs.langTable.getTable().tableData;
			}

			let rowSpanKey = ['userSelect', 'tableState', 'langId'];
			if (
				rowSpanKey.findIndex(item => {
					return item == column.property;
				}) >= 0
			) {
				let spanIndex = 0;
				let rowSpanCount = 0;
				var keyName = 'langId';
				if (row.rowType === 'add') {
					keyName = 'tmpKey';
				}

				// checkBox -> change selection
				if (column.property == 'userSelect') {
					this.userSelectionChange(row, keyName);
				}

				let currentKey = this.currentTableData[rowIndex][keyName];
				let prevKey = rowIndex > 0 ? this.currentTableData[rowIndex - 1][keyName] : null;

				if (prevKey != currentKey) {
					rowSpanCount = 1;
					for (let i = rowIndex + 1; i < this.currentTableData.length; i++) {
						if (currentKey == this.currentTableData[i][keyName]) {
							rowSpanCount++;
						} else {
							break;
						}
					}

					spanIndex = rowIndex;
				}

				if (rowIndex == spanIndex) {
					return {
						rowspan: rowSpanCount,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},
		resetTable() {
			this.$sf_toggleLoading(true);
			this.selectCommCdLangList_({ currentPage: this.commCdLangModal.groups.currentPage, pageUnit: this.commCdLangModal.groups.pageUnit })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		resetSelection() {
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.resetTable();
		},

		// Editable methods
		addAction() {
			this.makeAddDatas();
			this.rows.unshift(...this.addRowDatas);
			this.addRowDatas.forEach(row => {
				this.$refs.langTable.getTable().toggleRowSelection(row);
			});
		},
		saveAction() {
			const selected = this.$refs.langTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},
		deleteAction() {
			const selected = this.$refs.langTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000108'), //삭제하시겠습니까??
				buttons: [{ title: this.getMessage_('SWCC000328'), clickFn: () => this.remove() }] //저장
			});
		},
		save(saveRows) {
			try {
				// 유효성 검사
				this.schema1.validateSync(saveRows);
				this.schema2.validateSync([{ ...saveRows[0] }]);

				let sendData = this.makeSendDataSet();

				let requiredKeys = ['langId', 'langCd', 'langVal'];
				let messages = [];
				for (let i = 0; i < sendData.length; i++) {
					for (let j = 0; j < sendData[i].length; j++) {
						requiredKeys.forEach(item => {
							if (sendData[i][j][item] == undefined || sendData[i][j][item] == null || sendData[i][j][item] == '') {
								messages.push(item);
							}
						});

						if (messages.length > 0) {
							this.$sf_showMessage({
								title: this.getMessage_('SWCC000415'), //입력 정보를 확인해주세요.
								message: this.getMessage_('SWCC000416') // 메시지ID, 시스템, 메시지타입, 메시지내용 필수 입력.
							});
							break;
						}
					}

					if (messages.length > 0) {
						sendData = [];
						break;
					}
				}

				if (sendData != undefined && sendData.length > 0) {
					this.$sf_toggleLoading(true);
					this.saveCommCdLangList_(sendData)
						.then(value => {
							if (value.message != undefined && value.message != null) {
								this.$sf_toast({
									type: value.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(value.messageCd)
								});
							}
							this.resetTable();
						})
						.catch(error => {
							this.$sf_toast({
								type: 'error',
								message: error.message
							});
							Promise.reject(error);
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		remove() {
			let sendData = [];
			this.$refs.langTable.multipleSelection.forEach(row => {
				if (row.langId != '') {
					sendData.push(row.langId);
				}
			});

			this.$sf_toggleLoading(true);
			this.deleteCommCdLangList_(sendData)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		makeAddDatas() {
			let randomKey = 'ADD' + (Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000);
			let enUsName = this.optionLangs.filter(item => item.commCd == 'en_US')[0].commCdName;
			let koKrName = this.optionLangs.filter(item => item.commCd == 'ko_KR')[0].commCdName;
			let loLnName = this.optionLangs.filter(item => item.commCd == 'zh_CH')[0].commCdName;

			this.addRowDatas = [
				{
					rowType: 'add',
					rnum: '',
					userSelect: true,
					langId: '',
					tmpKey: randomKey,
					langCd: 'en_US',
					langCdDesc: enUsName,
					langVal: ''
				},
				{
					rowType: 'add',
					rnum: '',
					langId: 'dummy',
					tmpKey: randomKey,
					langCd: 'ko_KR',
					langCdDesc: koKrName,
					langVal: ''
				},
				{
					rowType: 'add',
					rnum: '',
					langId: 'dummy',
					tmpKey: randomKey,
					langCd: 'zh_CH',
					langCdDesc: loLnName,
					langVal: ''
				}
			];
		},
		makeSendDataSet() {
			let returnDataSet = [];
			let subSet = [];
			let sendKeys = [];
			this.$refs.langTable.multipleSelection.forEach(row => {
				let keyName = 'langId';
				if (row.rowType === 'add') {
					keyName = 'tmpKey';
				}

				if (
					sendKeys.length == 0 ||
					(sendKeys.length > 0 &&
						sendKeys.findIndex(item => {
							return item == row[keyName] && row[keyName] != '';
						}) < 0)
				) {
					sendKeys.push(row[keyName]);
				}
			});

			for (let i = 0; i <= sendKeys.length; i++) {
				this.$refs.langTable.multipleSelection.forEach(row => {
					let keyName = 'langId';
					if (row.rowType === 'add') {
						keyName = 'tmpKey';
					}

					if (sendKeys[i] == row[keyName]) {
						let pushSet = {
							langId: row.langId,
							langCd: row.langCd,
							langVal: row.langVal
						};
						['langId', 'langCd', 'langVal'].forEach(key => {
							if (row[key] == '' || row[key] == undefined) {
								subSet.forEach(item => {
									if (item[key] != '') {
										pushSet[key] = item[key];
									}
								});
							}
						});

						subSet.push(pushSet);

						sendKeys.filter(ele => ele != sendKeys[i]);
					}
				});

				if (subSet.length > 0) {
					returnDataSet.push(subSet);
				}

				subSet = [];
			}

			return returnDataSet;
		},

		// Selectable methods
		selectLangId(paramRow) {
			this.$refs.langTable.getTable().tableData.forEach(row => {
				if (paramRow != null && row.langId == paramRow.langId) {
					row.userSelect = true;

					paramRow.userSelect = true;
					this.langSelectionChange(row);
					paramRow = null;
				}
			});

			this.$emit('closeModal');
		},
		langSelectionChange(paramRow) {
			this.selectedRow = paramRow;
			this.$refs.langTable.getTable().tableData.forEach(row => {
				if (row.langId != paramRow.langId) {
					row.userSelect = false;
				}

				if (row.langId == paramRow.langId) {
					this.selectedRow = row;
				}
			});

			this.$refs.langTable.multipleSelection = [];
			if (paramRow.userSelect == true) {
				this.$refs.langTable.multipleSelection.push(paramRow);
			}
		}
	},
	created() {
		this.columns[2].options = this.gridLangCdype;
	}
};
</script>

<style></style>
